var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"history-list"},[_vm._l((_vm.data),function(item){return [_c('history-item',{key:item.date,attrs:{"date":item.date,"data":item.data,"type":item.type}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }